import ButtonOverride from "../../../../components/buttonoverride";
import ToggleButton from "../../../../components/togglebutton";
import styles from '../../../../styles/expenditureworksheet.module.css';
import { Button, Col, Row, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleArrowLeft, faPlus, faSave } from "@fortawesome/free-solid-svg-icons";
import { useForm } from 'react-hook-form';
import React, { useEffect, useRef, useState } from "react";
import FormInputValidationMessage from "../../../../components/forminputvalidationmessage";
import useApi from "../../../../hooks/use-api";
import useMessageStore from "../../../../stores/message-store";

const MultiViewAddEdit = ({ApplicationID,targetId,title, expenseTypeOptions = [],frequencyOptions = [],restrictOneTime = false,getEnpoint,addEndpoint,updateEndpoint,returnFunction, refreshFunction, readOnly = false}) => {
    const [mode, setMode] = useState('oneTime');
    const [isLoading,setIsLoading] = useState(() => targetId ? true : false);
    const firstRender = useRef(true);

    const {getRequest,postRequest,putRequest} = useApi();

    const addToast = useMessageStore(state => state.addToast);
  
    const {
      register,
      handleSubmit,
      watch,
      reset,
      resetField,
      formState: { errors, isSubmitting, isDirty }
    } = useForm({
      defaultValues: {
        expensetype: '',
        comments: '',
        onetimeamount: '',
        frequency: '',
        unit: '',
        rate: '',
        months: '',
      }
    });

    const _normalizeFields = (data) => {
      return {
        expensetype:   data.expensetypeid,
        comments:      data.comments    || '',
        onetimeamount: `${data.onetimeamount}` ?? '',
        frequency:     `${data.frequency}`  ?? '',
        unit:          `${data.unit}`       ?? '',
        rate:          `${data.rate}`       ?? '',
        months:        `${data.months}`     ?? '',
      }
    }

    const get = async() => {
      setIsLoading(true);
      const [data,status] = await getRequest(getEnpoint,{CostID: targetId,timestamp: Date.now()});

      setIsLoading(false);

      if(status === 200){
        setMode(data.isunitrate ? 'unitRate' : 'oneTime');
        const resetData = _normalizeFields(data);

        reset(resetData);
      }

    }
  
    // load for edit mode
    useEffect(() => {
      if (!targetId) return;

      get();
    }, [targetId]);
  
    // clear other‐mode fields + their dirty state
    useEffect(() => {
      if (firstRender.current) {
        firstRender.current = false;
        return;
      }
      if (mode === 'oneTime') {
        ['frequency', 'unit', 'rate', 'months'].forEach(f => resetField(f));
      } else {
        resetField('onetimeamount');
      }
    }, [mode, resetField]);
  
    // watch and parse
    const oneTimeAmt = parseFloat(watch('onetimeamount')) || 0;
    const freqId     = watch('frequency');
    const units      = parseFloat(watch('unit'))    || 0;
    const rateNum    = parseFloat(watch('rate'))    || 0;
    const monthsNum  = parseFloat(watch('months'))  || 0;
  
    const freqOpt    = frequencyOptions.find(o => String(o.id) === String(freqId));
    const multiplier = freqOpt ? parseFloat(freqOpt.factor) : 0;
  
    const grandTotal =
      mode === 'oneTime'
        ? oneTimeAmt
        : units * rateNum * monthsNum * multiplier;
  
    const onSubmit = async vals => {
      if(readOnly){
        return;
      }

      const payload = {
        isunitrate:    mode === 'unitRate',
        expensetypeid: vals.expensetype,
        comments:      vals.comments,
        onetimeamount:
          mode === 'oneTime' ? parseFloat(vals.onetimeamount) : null,
        frequency:
          mode === 'unitRate'  ? vals.frequency : null,
        unit:
          mode === 'unitRate'  ? parseInt(vals.unit, 10) : null,
        rate:
          mode === 'unitRate'  ? parseFloat(vals.rate) : null,
        months:
          mode === 'unitRate'  ? parseInt(vals.months, 10) : null,
      };
      
  
      if(targetId){
        const [data,status] = await putRequest(updateEndpoint,{id: targetId,...payload});

        if(status === 200){
          addToast(
            {
                id: Math.random(),
                body: "The Cost was succesfully updated!",
                autoHide: true,
                errorFlag: false,
                timestamp: Date.now() - 1000
            }
          )

          reset(_normalizeFields(data));

          refreshFunction();
        }
        else{
          addToast(
            {
                id: Math.random(),
                body: "An error occured when updating the cost.",
                autoHide: true,
                errorFlag: true,
                timestamp: Date.now() - 1000
            }
          )
        }
      }
      else{
        const [,status] = await postRequest(addEndpoint,{ApplicationID: ApplicationID, ...payload});

        if(status === 201){
          addToast(
            {
                id: Math.random(),
                body: "The Cost was succesfully added!",
                autoHide: true,
                errorFlag: false,
                timestamp: Date.now() - 1000
            }
          )

          refreshFunction();
          returnFunction();
        }
        else{
          addToast(
            {
                id: Math.random(),
                body: "An error occured when adding the cost.",
                autoHide: true,
                errorFlag: true,
                timestamp: Date.now() - 1000
            }
          )
        }
        
      }
    };

    const handleToggle = () => {
        if(mode === 'unitRate'){
            setMode('oneTime');
        }
        else{
            setMode('unitRate')
        }
    }

    if(isLoading){
      return(
        <div>...loading</div>
      )
    }
  
    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="clientCard">
            <div className="clientCardInner">
                <div className={styles.expenditureSubNavContainer}>
                    <ButtonOverride type="button" className={styles.expenditureSubNavBackButton} aria-label="Return" onClick={returnFunction}>
                        <FontAwesomeIcon icon={faCircleArrowLeft} size="2xl" />
                    </ButtonOverride>
                    <h5 className={styles.expenditureSubNavTitle}>
                        {targetId === null ? <>Add {title} Cost</> : readOnly ? <>View {title} Cost #{targetId}</> : <>Edit {title} Cost #{targetId}</>}
                    </h5>
                </div>
                <div className={`${styles.addEditForm} mt-4`}>
                    {
                        (!targetId && !restrictOneTime) && (
                            <Row className="d-flex justify-content-center mt-2">
                                <Col xs='auto'>
                                    <ToggleButton isOn={mode === 'unitRate'} handleToggle={handleToggle} variant="success" onText={'Unit'} offText={'Amount'} />
                                </Col>
                            </Row>
                        )
                    }
                    <Row>
                        <Col xs={12} md={4}>
                            <label className="fw-bold" htmlFor="expenseType">Expense Type</label>
                            <select id="expenseType" {...register('expensetype', { required: 'Required' })} style={{width: '100%'}}>
                                <option value="">--Select Expense Type--</option>
                                {expenseTypeOptions.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                            <FormInputValidationMessage error={errors.expensetype} />
                            {
                                mode === 'oneTime' && (
                                    <div>
                                        <label className="fw-bold" htmlFor="onetimeamount">Amount ($)</label><br/>
                                        <input id="onetimeamount" type="number" step="0.01" {...register('onetimeamount', { required: 'Enter an amount' })} style={{width: '100%'}}/>
                                        <FormInputValidationMessage error={errors.oneTimeAmount} />
                                    </div>
                                )
                            }
                        </Col>
                        <Col xs={12} md={8}>
                            <label className="fw-bold" htmlFor="comments">Comments</label>
                            <textarea id="comments" {...register('comments')} style={{ width: '100%' }} rows={4} />
                        </Col>
                    </Row>
                    {
                        mode === 'unitRate' && (
                            <Row>
                                <Col xs={12} md={2}>
                                    <label className="fw-bold" htmlFor="unit">Units (per period)</label>
                                    <input id="unit" type="number" step="1" {...register('unit', { required: 'Required' })} style={{width: '100%'}} />
                                    <FormInputValidationMessage error={errors.unit} />
                                </Col>
                                <Col xs={12} md={2}>
                                    <fieldset>
                                        <legend className="fw-bold" style={{fontSize: '1rem',marginBottom: '0'}}>Frequency</legend>
                                        {
                                            frequencyOptions.map((item,index) => (
                                                <div key={item.id}>
                                                    <input {...register('frequency', { required: 'Required' })} type="radio" id={`freqtype${index}`} value={item.id} />
                                                    <label htmlFor={`freqtype${index}`}>{item.name}</label>
                                                </div>
                                            ))
                                        }
                                    </fieldset>
                                    <FormInputValidationMessage error={errors.frequency} />
                                </Col>
                                <Col xs={12} md={2}>
                                    <label className="fw-bold" htmlFor="rate">Rate ($ per unit)</label>
                                    <input id="rate" type="number" step="0.01" {...register('rate', { required: 'Enter a rate' })} style={{width: '100%'}}/>
                                    <FormInputValidationMessage error={errors.rate} />
                                </Col>
                                <Col xs={12} md={2}>
                                    <label className="fw-bold" htmlFor="months">Months</label><br/>
                                    <input id="months" type="number" {...register('months', { required: 'Enter months' })} style={{width: '100%'}}/>
                                    <FormInputValidationMessage error={errors.months} />
                                </Col>
                            </Row>
                        )
                    }
                    <Row>
                        <Col xs={12}>
                        <div style={{ marginBottom: 24, fontSize: '1.1em' }}>
                        <strong>Grand Total:</strong> ${grandTotal.toFixed(2)}
                        </div>
                        </Col>
                    </Row>
                </div>
                <div className="d-flex justify-content-between align-items-center mt-2">
                    <Button type="button" variant={readOnly ? "secondary" : "danger"} onClick={returnFunction} disabled={isSubmitting}>{readOnly ? "Return" : "Cancel"}</Button>
                    {
                        !readOnly
                        ?
                            <Button type="submit" variant={targetId !== null ? 'primary' : 'success'} disabled={isSubmitting || !isDirty}>
                                {
                                    isSubmitting
                                    ?
                                        <Spinner animation='border' size='sm' />
                                    :
                                        targetId
                                        ?
                                            <>
                                                <FontAwesomeIcon icon={faSave} size="xl" className="me-1" />
                                                Save Changes
                                            </>
                                        :
                                            <>
                                                <FontAwesomeIcon icon={faPlus} size="xl" className="me-1" />
                                                Add Estimate
                                            </>
                                }
                            </Button>
                        :
                            null
                    }
                </div>
            </div>
        </div>
      </form>
    );
  
}

export default MultiViewAddEdit;
